import { createApp } from 'vue';
import App from './App.vue';
import router from '../src/router/index';
import 'moment';
import { store } from '../src/store/index';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

createApp(App)
    .use(store)
    .use(router)
    .use(VCalendar)
    .mount('#app');